import {accountDestinations,accountPages} from '../features/account/accountNavigation';
// Incoming URLs select destinations only. They never carry financial or entitlement proof.
const KEY = 'finflow_pending_return_v1';
const TTL = 60 * 60 * 1000;
export function supportedReturn(raw: string): string | null {
 try {
  if (!raw || raw.length > 2048 || /[\\\r\n]/.test(raw) || /%(?:2f|5c|00)/i.test(raw)) return null;
  let url: URL;
  if (raw.startsWith('/') && !raw.startsWith('//')) url = new URL(raw, 'https://finflowfinance.com');
  else { url = new URL(raw); if (url.protocol === 'finflow:') {
    if (url.username || url.password || url.port) return null;
    url = new URL('/' + url.hostname + url.pathname + url.search, 'https://finflowfinance.com');
  } else if (url.origin !== 'https://finflowfinance.com') return null; }
  if (url.hash || url.username || url.password) return null;
  const p = url.pathname, q = url.searchParams;
  if (q.has('oobCode') || q.has('apiKey') || q.has('continueUrl')) return null; // Firebase hosted action handler owns these.
  if (p === '/provider-return/plaid') return '/account?section=bank-sync&provider_return=1';
  if (/^\/r\/[A-Za-z0-9_-]{1,256}$/.test(p)) return p;
  if (p === '/login') return q.get('reset') === '1' ? '/login?reset=1' : '/login';
  if (p === '/checkout/success') {
    const id = q.get('session_id');
    return id && /^cs_[A-Za-z0-9_]{1,240}$/.test(id) ? p + '?session_id=' + id : '/account?section=subscription';
  }
  if (p === '/checkout/cancel') return p;
  if (p === '/account') {
    const section = q.get('section');
    if (section === 'subscription') return '/account?section=subscription' + (q.get('portal_return') === '1' ? '&portal_return=1' : '');
    if (section === 'bank-sync') return '/account?section=bank-sync' + (q.get('provider_return') === '1' ? '&provider_return=1' : '');
    return '/account';
  }
  const aliases: Record<string,string> = {'/expenses':'/activity','/goals':'/plan/goals','/dashboard':'/dashboard'};
  if (aliases[p]) return aliases[p];
  return ['/activity','/plan','/plan/goals','/plan/debt'].includes(p) ? p : null;
 } catch { return null; }
}
// Internal app navigation can retain known Account leaves without expanding native inbound URLs.
export function supportedTaskReturn(raw:string):string|null {
 try {
  if(!raw.startsWith('/')||raw.startsWith('//')||/[\\\r\n]/.test(raw))return null;
  const url=new URL(raw,'https://finflowfinance.com');
  if(url.pathname==='/account'&&!url.hash){
   const section=url.searchParams.get('section');
   if(section&&(Object.prototype.hasOwnProperty.call(accountPages,section)||accountDestinations.some(x=>x.id===section)))
    return '/account?section='+encodeURIComponent(section)+(section==='subscription'&&url.searchParams.get('portal_return')==='1'?'&portal_return=1':section==='bank-sync'&&url.searchParams.get('provider_return')==='1'?'&provider_return=1':'');
  }
  if(url.pathname==='/activity/categories'&&!url.search&&!url.hash)return url.pathname;
  return supportedReturn(raw);
 }catch{return null;}
}
export function rememberReturn(path: string) {
 const safe = supportedTaskReturn(path); if (!safe || safe.startsWith('/login')) return;
 try { localStorage.setItem(KEY, JSON.stringify({path:safe, expires:Date.now()+TTL})); } catch {}
}
export function pendingReturn(consume=false): string | null {
 try {
  const item = JSON.parse(localStorage.getItem(KEY)||'null');
  if (!item || typeof item.expires!=='number'||!Number.isFinite(item.expires)||item.expires < Date.now()) { localStorage.removeItem(KEY); return null; }
  const path = supportedTaskReturn(item.path);
  if (consume || !path) localStorage.removeItem(KEY);
  return path;
 } catch { return null; }
}
export function acceptIncoming(raw: string) {
 const path = supportedReturn(raw); if (!path) {
  try{localStorage.setItem('finflow_link_issue',JSON.stringify({kind:raw.includes('oobCode=')?'password':'unsupported',expires:Date.now()+TTL}));}catch{}
  window.dispatchEvent(new Event('finflow-link-issue'));return;
 }
 rememberReturn(path);
 window.dispatchEvent(new CustomEvent('finflow-incoming-link', {detail:{path}}));
}

export function takeLinkIssue(): 'password'|'unsupported'|null {
 try{const item=JSON.parse(localStorage.getItem('finflow_link_issue')||'null');localStorage.removeItem('finflow_link_issue');return item&&item.expires>Date.now()?(item.kind==='password'?'password':'unsupported'):null;}catch{return null;}
}
